export const SET_CANTEEN_DATA = 'SET_CANTEEN_DATA';
export const DELETE_CANTEEN_DATA = 'DELETE_CANTEEN_DATA';